export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20cozy%20night%20reading%20nook%20surrounded%20by%20floating%20books%2C%20lanterns%20and%20constellations%2C%20warm%20candlelight%2C%20dusty%20rose%20and%20cream%20and%20soft%20gold%20palette%2C%20magical%20manga%20background%20art%2C%20detailed%20and%20atmospheric&width=1600&height=900&seq=dj-hero-01&orientation=landscape"
          alt="今日同人库阅读与追更的氛围插画"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto py-20 md:py-28 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-300/40 text-accent-200 text-xs md:text-sm font-medium mb-6">
          <i className="ri-flashlight-fill"></i>
          每日更新速递 · 今日上线
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
          今日同人库，<span className="text-accent-300">今日更新</span>
          一手掌握
        </h1>
        <p className="mt-6 text-background-100 text-sm md:text-lg max-w-2xl leading-relaxed">
          第一时间掌握今日同人库更新动态——最新汉化进度、新作连载更新、热门追更作品，每日整理推送，让你不再错过任何一个章节。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#today"
            className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看今日更新
          </a>
          <a
            href="#categories"
            className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            浏览主题分类
          </a>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 w-full max-w-3xl">
          {[
            { num: '480+', label: '在追作品' },
            { num: '126', label: '本周汉化更新' },
            { num: '36', label: '连载中作品' },
            { num: '9.8万', label: '累计阅读' },
          ].map((s) => (
            <div key={s.label} className="bg-background-50/10 border border-background-50/20 rounded-lg py-4 px-2 backdrop-blur-sm">
              <p className="font-heading text-2xl md:text-3xl font-bold text-accent-300">{s.num}</p>
              <p className="mt-1 text-background-200 text-xs md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}